import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const Button = ({ 
  to = "#", 
  children, 
  variant = "saffron", 
  className = "",
  textClassName = "",
   onClick,
}) => {
  const variants = {
    saffron: {
      button:
        "!border-saffron !bg-saffron hover:!border-maroon hover:!bg-maroon",
      text: "text-white group-hover:text-maroon",
      circle: "bg-white",
      icon: "text-saffron group-hover:text-maroon",
    },

    maroon: {
      button:
        "!border-maroon !bg-maroon hover:!border-saffron hover:!bg-saffron",
      text: "text-white group-hover:text-maroon",
      circle: "bg-white",
      icon: "text-maroon group-hover:text-saffron",
    },

    blood: {
      button:
        "!border-blood !bg-blood hover:!border-maroon hover:!bg-maroon",
      text: "text-white group-hover:text-white",
      circle: "bg-white",
      icon: "text-blood group-hover:text-maroon",
    },

    purple: {
      button:
        "!border-purpleTxt !bg-purpleTxt hover:!border-purpleTxt hover:!bg-purple",
      text: "text-white group-hover:!text-purpleTxt",
      circle: "bg-white",
      icon: "text-purpleTxt hover:!text-purpleTxt",
    },

    darkPink: {
      button:
        "!border-darkPink !bg-darkPink hover:!border-darkPink hover:!bg-pink",
      text: "text-white group-hover:!text-red",
      circle: "bg-white",
      icon: "text-darkPink hover:!text-darkPink",
    },

    blue: {
      button:
        "!border-blue-txt !bg-blue-txt hover:!border-blue-txt hover:!bg-blue-bg",
      text: "text-white group-hover:!text-blue-txt",
      circle: "bg-white",
      icon: "text-blue-txt hover:!text-darkPink",
    },

    green: {
      button:
        "!border-green-txt !bg-green-txt hover:!border-green-txt hover:!bg-green-bg",
      text: "text-white group-hover:!text-green-txt",
      circle: "bg-white",
      icon: "text-green-txt hover:!text-green-txt",
    },

    orange: {
      button:
        "!border-orange-txt !bg-orange-txt hover:!border-orange-txt hover:!bg-orange-bg",
      text: "text-white group-hover:!text-orange-txt",
      circle: "bg-white",
      icon: "text-orange-txt hover:!text-orange-txt",
    },

    pink: {
      button:
        "!border-darkPink !bg-darkPink hover:!border-darkPink hover:!bg-lightPink",
      text: "text-white group-hover:!text-darkPink",
      circle: "bg-white",
      icon: "text-darkPink group-hover:!text-darkPink",
    },

    gray: {
      button:
        "!border-gray-text !bg-gray-text hover:!border-gray-text hover:!bg-gray-bg",
      text: "text-white group-hover:!text-gray-text",
      circle: "bg-white",
      icon: "text-gray-text hover:!text-gray-text",
    },

    outline: {
      button: "!border-maroon !bg-white hover:!bg-maroon",
      text: "text-maroon group-hover:text-white",
      circle: "bg-maroon group-hover:bg-white",
      icon: "text-white group-hover:!text-maroon",
    },

    white: {
      button:
        "!border-[#F8F8F8] !bg-[#F8F8F8] hover:!border-white",
      text: "text-maroon group-hover:text-blood",
      circle: "bg-maroon group-hover:bg-blood",
      icon: "text-white",
    },
  };

  const colors = variants[variant] || variants.saffron;

return (
  <Link
    to={to}
     onClick={onClick}
    className={`
      group inline-flex shrink-0 items-center justify-center rounded-full border
      overflow-hidden whitespace-nowrap transition-all duration-300
      p-1 lg:p-2
      ${colors.button}
      ${className}
    `}
  >
    {/* Text */}
    <div className="relative h-5 min-w-0 flex-1 overflow-hidden px-2.5 lg:h-6 lg:px-3">
      <div className="flex flex-col transition-transform duration-300 group-hover:-translate-y-5 lg:group-hover:-translate-y-6">
        <span
          className={`
            flex h-5 lg:h-6 items-center justify-center truncate whitespace-nowrap
            text-xs lg:text-sm font-semibold transition-all duration-300
            ${colors.text}
            ${textClassName}
          `}
        >
          {children}
        </span>

        <span
          className={`
            flex h-5 lg:h-6 items-center justify-center truncate whitespace-nowrap
            text-xs lg:text-sm font-semibold transition-all duration-300
            ${colors.text}
            ${textClassName}
          `}
        >
          {children}
        </span>
      </div>
    </div>

    {/* Arrow */}
    <span
      className={`
        ml-1 lg:ml-2
        flex h-8 w-8 lg:h-10 lg:w-10
        shrink-0 items-center justify-center
        rounded-full transition-all duration-300
        ${colors.circle}
      `}
    >
      <ArrowRight
        className={`
          h-4 w-4 lg:h-5 lg:w-5
          shrink-0 -rotate-45
          transition-all duration-300
          group-hover:rotate-0
          group-hover:translate-x-0.5
          ${colors.icon}
        `}
      />
    </span>
  </Link>
);
};

export default Button;
